









































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { ZAKAZKA_DRUH, ZAKAZKA_STAV } from '../../constants';
import { getStavZakazka } from '../../utils';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'Historie',
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			ZAKAZKA_DRUH,
			ZAKAZKA_STAV,
		};
	},
	computed: {
		...genVuexComputeds(store),
		showZaplanovalZaplanovano(): boolean {
			if (this.dmsSys.CancelOrRescheduleOrdrPrp && this.zakazkaStav === ZAKAZKA_STAV.V_PRIPRAVE) {
				return true;
			}
			const ZakazkaDruhWhiteList = [ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.GARANCE, ZAKAZKA_DRUH.INTERNI_DILENSKA, ZAKAZKA_DRUH.KULANCE, ZAKAZKA_DRUH.MONTAZ_DV,
				ZAKAZKA_DRUH.UDRZBA_OV, ZAKAZKA_DRUH.SKODA_TIP];
			return this.ZakazkaDruh ? ZakazkaDruhWhiteList.includes(this.ZakazkaDruh as ZAKAZKA_DRUH) : false;
		},
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
		enableCabcelReschedule(): boolean {
			return this.zakazkaStav === ZAKAZKA_STAV.V_PRIPRAVE;
		},
	},
});
